import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.2 5.80001V4.40001C7.2 3.88454 7.61787 3.46667 8.13333 3.46667H11.8667C12.3821 3.46667 12.8 3.88454 12.8 4.40001V5.80001M3 6.26667H17M4.4 6.26667V15.6C4.4 16.1155 4.81787 16.5333 5.33333 16.5333H14.6667C15.1821 16.5333 15.6 16.1155 15.6 15.6V6.26667M10 9.53334V14.2M7.2 11.4V14.2M12.8 11.4V14.2",
  stroke: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "delete",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})